import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IHowToInviteFriendsModal {
  onCloseInfoModal: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
    strong: {
      fontWeight: 'bold',
    },
  })
)

export const HowToInviteFriendsModal = ({
  onCloseInfoModal,
}: IHowToInviteFriendsModal) => {
  const classes = useStyles()
  return (
    <CustomDialogContent
      title="How can I invite my friends?"
      onCancel={onCloseInfoModal}
    >
      <Typography variant="h5">
        You can also invite your friends to one of your groups.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        1. Hit the <span className={classes.strong}>Add Member</span> button from the
        group menu in the Home page.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        2. Alternatively, open one of your{' '}
        <span className={classes.strong}>groups</span> and hit the
        <span className={classes.strong}> Add Member</span> button
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        3 <span className={classes.strong}>Invite</span> your friends searching by
        their <span className={classes.strong}>username</span>.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        4. If your friends don&apos;t have a username and they are not registered in
        the app, no worries you can invite them using their
        <span className={classes.strong}> email address</span>. Just type their
        address in the e-mail box and click on.
        <span className={classes.strong}> Send Invitation</span>.
      </Typography>
    </CustomDialogContent>
  )
}
